import React from 'react';
import MarketingLayout from './MarketingLayout';
import { useDocumentMeta } from '../../hooks/useDocumentMeta';

const serviceScopes = [
  {
    title: '美国海外仓',
    desc: '提供入库、存储、一件代发(拣货、打包、发货)、换标、重新包装、质检等仓配服务,主要服务月订单量数百至数千单的中小跨境卖家,支持 Walmart、Amazon、eBay、TikTok Shop、Temu、Shein 等多平台订单履约。',
  },
  {
    title: '美国免税州海淘转运',
    desc: '依托美国免税州的仓储优势,为海淘用户提供收货、合并包裹、转运出库服务,帮助客户降低采购与运输成本。',
  },
  {
    title: '国际快递物流',
    desc: '整合多家承运商资源,提供美国境内及跨境的快递与物流配送服务,并可根据货物特点匹配合适的运输方案。',
  },
  {
    title: '商品采购与分销代理',
    desc: '为客户提供商品采购、供应对接与分销代理服务,协助客户打通从货源到终端销售的链路。',
  },
];

const AboutPage: React.FC = () => {
  useDocumentMeta({
    title: '关于我们',
    description:
      '安飞供应链(AnFei Supply Chain)是一家专注于中美跨境供应链服务的综合服务商，总部/仓库位于美国东部免税州，为跨境电商卖家提供从采购、仓储、转运到国际配送的一站式解决方案。',
  });

  return (
    <MarketingLayout>
      <section className="mx-auto max-w-6xl px-6 py-14">
        <h1 className="text-3xl font-bold text-gray-900">关于我们</h1>
        <p className="mt-4 max-w-4xl text-sm leading-8 text-gray-600">
          安飞供应链(AnFei Supply Chain)是一家专注于中美跨境供应链服务的综合服务商,为跨境电商卖家、海淘用户及贸易客户提供从采购、仓储、转运到国际配送的一站式解决方案。公司成立于2021年,总部/仓库位于美国东部免税州Nashua NH 03060,公司注册名称"An &amp; Fei Corp"。
        </p>

        <h2 className="mt-8 text-xl font-semibold text-gray-900">主要服务范围</h2>
        <ul className="mt-3 max-w-4xl space-y-2 text-sm leading-8 text-gray-600">
          {serviceScopes.map((item) => (
            <li key={item.title}>
              <span className="font-semibold text-gray-900">{item.title}:</span>
              {item.desc}
            </li>
          ))}
        </ul>

        <h2 className="mt-8 text-xl font-semibold text-gray-900">核心优势</h2>
        <p className="mt-3 max-w-4xl text-sm leading-8 text-gray-600">
          公司仓储运营基于自主研发的仓库管理系统(WMS),支持多层级库存管理、指令化可追溯的作业流程、严格的库存锁定机制、运单自动匹配与事件驱动的自动计费,保障作业准确、账目清晰。公司正在推进与主流电商平台(Amazon Walmart Ebay Temu TiktokShop Shein...)及ERP软件(领星 马帮 店小秘 通途...)的订单自动同步对接,减少人工处理环节,提升发货效率与准确性。
        </p>

        <p className="mt-6 max-w-4xl text-sm leading-8 text-gray-600">
          我们坚持稳健、透明、可追溯的服务原则,致力于成为跨境卖家值得信赖的美国本土供应链伙伴。
        </p>
      </section>

      <section className="mx-auto grid max-w-6xl gap-4 px-6 pb-20 md:grid-cols-3">
        <div className="rounded-xl border border-[#d9eaff] bg-white p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900">公司定位</h3>
          <p className="mt-2 text-sm leading-7 text-gray-600">
            以仓储与履约为核心，逐步扩展供应链服务边界。
          </p>
        </div>
        <div className="rounded-xl border border-[#d9eaff] bg-white p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900">服务原则</h3>
          <p className="mt-2 text-sm leading-7 text-gray-600">
            真实交付、公开透明、快速响应、长期协同。
          </p>
        </div>
        <div className="rounded-xl border border-[#d9eaff] bg-white p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-gray-900">发展方向</h3>
          <p className="mt-2 text-sm leading-7 text-gray-600">
            建立全球各主要市场的仓储与供应链协同网络,打造全场景全地域服务体系.
          </p>
        </div>
      </section>
    </MarketingLayout>
  );
};

export default AboutPage;
